import React, { useContext, useState, useEffect } from 'react';

import HeaderStroke from '../../HeaderStroke';

// import Header from "./Header";

import Paginacao from '../../Paginacao';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import { ContextSolicitacoes } from '../../../services/solicitacoes';

import { NovaSolicitacaoBtn } from './styles';

import { ReactComponent as Plus } from '../../../assets/novosicones/Solicitacoes/LerMais.svg';
import NenhumaSolicitacaoCriada from '../../../Pages/Sindico/SolicitacoesSindico/NenhumaSolicitacaoCriada';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Spinner } from '../../StyledComponent';
const TodasSolicitacoes = () => {
  const [filtroPorStatus, setFiltroPorStatus] = useState('Todos');
  const history = useHistory();

  const { tema } = useContext(ContextoListaApartamentos);

  const {
    minhasSolicitacoes,
    solicitacoes,
    loadingSolicitacoes,
    solicitacoesParaExibir,
    setSolicitacoesParaExibir,
    setLoadingSolicitacoes,
  } = useContext(ContextSolicitacoes);

  useEffect(() => {
    (async function () {
      setLoadingSolicitacoes(true);

      await minhasSolicitacoes();
    })();
  }, []);

  useEffect(() => {
    if (filtroPorStatus.includes('Todos'))
      setSolicitacoesParaExibir(solicitacoes);
    else {
      let temp = solicitacoes.filter((solicitacao) =>
        filtroPorStatus.includes(solicitacao.status)
      );
      setSolicitacoesParaExibir(temp);
    }
  }, [filtroPorStatus]);

  function redirectToNovaSolicitacao() {
    history.push('/solicitacoes/nova-solicitacao');
  }
  return (
    <>
      <div className='solicitacoesAgendamentos centralized-column '>
        <HeaderStroke name='Solicitações' msgDadosCadastrais={false} />

        {loadingSolicitacoes && <Spinner />}

        {solicitacoes?.length > 0 && (
          <NovaSolicitacaoBtn
            bg={tema.primaryColor}
            onClick={redirectToNovaSolicitacao}
            id='btnCriarNovaSolicitacao'
          >
            <a className='centralized'>
              <Plus style={{ fill: '#fff' }} />{' '}
              <span>criar nova solicitação</span>
            </a>
          </NovaSolicitacaoBtn>
        )}

        {!loadingSolicitacoes && !solicitacoes?.length > 0 && (
          <NenhumaSolicitacaoCriada
            functionOnClickNewSolicitation={redirectToNovaSolicitacao}
          />
        )}

        {!loadingSolicitacoes && solicitacoes?.length > 0 && (
          <Paginacao
            parcelas={solicitacoesParaExibir}
            tema={tema}
            tipo='solicitacoes'
            setFiltroPorStatus={setFiltroPorStatus}
            filtroPorStatus={filtroPorStatus}
          />
        )}
      </div>
    </>
  );
};

export default TodasSolicitacoes;
